import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Sidebar from "@/components/Sidebar";
import Dashboard from "@/pages/Dashboard";
import Arquivos from "@/pages/Arquivos";
import Ocorrencias from "@/pages/Ocorrencias";
import Notas from "@/pages/Notas";
import Ctes from "@/pages/Ctes";
import Mudancas from "@/pages/Mudancas";
import Transportadoras from "@/pages/Transportadoras";
import Regras from "@/pages/Regras";
import RastreioPublico from "@/pages/RastreioPublico";
import { TransportadoraProvider } from "@/contexts/TransportadoraContext";
import { TransportadoraBanner } from "@/components/TransportadoraBanner";

function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex">
      <Sidebar />
      <main className="flex-1 min-w-0 px-8 md:px-12 py-10">
        <TransportadoraBanner />
        {children}
      </main>
    </div>
  );
}

function App() {
  return (
    <TransportadoraProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#09090B",
              color: "#fff",
              border: "1px solid #27272A",
            },
          }}
        />
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="/transportadoras"
            element={
              <Layout>
                <Transportadoras />
              </Layout>
            }
          />
          <Route
            path="/arquivos"
            element={
              <Layout>
                <Arquivos />
              </Layout>
            }
          />
          <Route
            path="/ocorrencias"
            element={
              <Layout>
                <Ocorrencias />
              </Layout>
            }
          />
          <Route
            path="/notas"
            element={
              <Layout>
                <Notas />
              </Layout>
            }
          />
          <Route
            path="/ctes"
            element={
              <Layout>
                <Ctes />
              </Layout>
            }
          />
          <Route
            path="/mudancas"
            element={
              <Layout>
                <Mudancas />
              </Layout>
            }
          />
          <Route
            path="/regras"
            element={
              <Layout>
                <Regras />
              </Layout>
            }
          />
          <Route
            path="/rastreio/:token"
            element={<RastreioPublico />}
          />
        </Routes>
      </BrowserRouter>
    </TransportadoraProvider>
  );
}

export default App;
